"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetGSSServer = exports.setGSSToServerCookie = exports.getGSSPageProp = exports.GSS_STATE_PROP = void 0;
const isomorphic_unfetch_1 = __importDefault(require("isomorphic-unfetch"));
const libs_next_utils_1 = require("@hotelplan/libs.next-utils");
exports.GSS_STATE_PROP = '_gss';
function getGSSPageProp(pageProps) {
    const gssProp = (0, libs_next_utils_1.createPagePropGetter)(exports.GSS_STATE_PROP, null)(pageProps);
    // return pairs object for fallback
    return gssProp ? gssProp : { gss: null, fgss: null };
}
exports.getGSSPageProp = getGSSPageProp;
function setGSSToServerCookie(gssEndpoint, gssType, globalSearchState) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield (0, isomorphic_unfetch_1.default)(gssEndpoint, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    gss: JSON.stringify(globalSearchState),
                    gssType,
                }),
            });
        }
        catch (e) {
            // NOTE: Do nothing.
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
    });
}
exports.setGSSToServerCookie = setGSSToServerCookie;
function resetGSSServer(gssEndpoint) {
    return __awaiter(this, void 0, void 0, function* () {
        try {
            yield (0, isomorphic_unfetch_1.default)(gssEndpoint, { method: 'DELETE' });
        }
        catch (e) {
            // NOTE: Do nothing.
            if (process.env.NODE_ENV !== 'production') {
                // eslint-disable-next-line no-console
                console.error(e);
            }
        }
    });
}
exports.resetGSSServer = resetGSSServer;
//# sourceMappingURL=index.js.map